import permissions from './permissions_list'

// Define system roles
export const ROLES = Object.freeze({
    SYSTEMADMINS: "System Admin",
    SCHOOLADMINS: "School Admin",
    TEACHERS: "Teacher",
    HOD: "HOD/Year Leader",
});

export const PERMISSIONS = Object.freeze(permissions);